import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { retry, catchError } from 'rxjs/operators';

import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../services/auth.service';


@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

  constructor(
    private authService: AuthService,
    private router: Router,
    private toastr: ToastrService){}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          let errorFormat = {
            message: '',
            code: '',
            errors: {}
          };
          
          if (error.error instanceof ErrorEvent) {
            // client-side error
            errorFormat.message = `Error: ${error.error.message}`;
          } else {
            
            this.toastr.clear();

          
            // server-side error
            switch (error.status) {
              case 0:
                errorFormat.message = `Aviso: Falha na comunicação com o servidor. Por favor, Verifique sua conexão ou aguarde para tentar novamente!!`;
                this.toastr.error(errorFormat.message, null, {
                  positionClass: 'toast-bottom-center',
                  progressAnimation: 'decreasing',
                  progressBar: true,
                  timeOut: 5000
                });
                break;
              case 400: 
                errorFormat.code =  error.error.hasOwnProperty('code') ? error.error.code : null;
                errorFormat.message = error.error.message ? `Aviso: ${error.error.message}` : 'Requisição não processada, tente novamente mais tarde!';
                this.toastr.warning(errorFormat.message, null, {
                  positionClass: 'toast-bottom-center',
                  progressAnimation: 'decreasing',
                  progressBar: true,
                  timeOut: 5000
                });
                break;
              case 401:
                errorFormat.code =  error.error.hasOwnProperty('code') ? error.error.code : null;
                errorFormat.message = error.error.message ? `Aviso: ${error.error.message}` : 'Você foi desconectado. Favor, você precisa informar suas credenciais!';
                sessionStorage.clear();
                this.toastr.error(errorFormat.message, null, {
                  positionClass: 'toast-bottom-center',
                  progressAnimation: 'decreasing',
                  progressBar: true,
                  timeOut: 5000
                });
                
                this.authService.logout();
                break;
              case 403:
                errorFormat.code =  error.error.hasOwnProperty('code') ? error.error.code : null;
                errorFormat.message = error.error.message ? `Aviso: ${error.error.message}` : 'Você não possui permissões para acessar esta página!';                
                this.toastr.warning(errorFormat.message, null, {
                  positionClass: 'toast-bottom-center',
                  progressAnimation: 'decreasing',
                  progressBar: true,
                  timeOut: 5000
                });       
                sessionStorage.clear();
                this.authService.logout();
                break;
              case 404:
                errorFormat.code =  error.error.hasOwnProperty('code') ? error.error.code : null;
                errorFormat.message = `Aviso: ${error.error.message}`;
                this.toastr.info(errorFormat.message, null, {
                  positionClass: 'toast-bottom-center',
                  progressAnimation: 'decreasing',
                  progressBar: true,
                  timeOut: 5000
                });
                break;
              case 405:
                errorFormat.code =  error.error.hasOwnProperty('code') ? error.error.code : null;
                errorFormat.message = `Aviso: ${error.error.message}`;
                this.toastr.error(errorFormat.message, null, {
                  positionClass: 'toast-bottom-center',
                  progressAnimation: 'decreasing',
                  progressBar: true,
                  timeOut: 5000
                });
                break;
              case 406:
                errorFormat.code =  error.error.hasOwnProperty('code') ? error.error.code : null;
                errorFormat.message = `Aviso: ${error.error.message}`;
                this.toastr.info(errorFormat.message, null, {
                  positionClass: 'toast-bottom-center',
                  progressAnimation: 'decreasing',
                  progressBar: true,
                  timeOut: 5000
                });
                break;
              case 422:
                errorFormat.code =  error.error.hasOwnProperty('code') ? error.error.code : null;
                errorFormat.message = `Aviso: ${error.error.message}`;
                errorFormat.errors = error.error.errors;
                this.toastr.warning(errorFormat.message, null, {
                  positionClass: 'toast-bottom-center',
                  progressAnimation: 'decreasing',
                  progressBar: true,
                  timeOut: 5000
                });
                break;
              case 429:
                errorFormat.message = `Favor, aguarde sua última requisição processar.`;
                this.toastr.warning(errorFormat.message, null, {
                  positionClass: 'toast-bottom-center',
                  progressAnimation: 'decreasing',
                  progressBar: true,
                  timeOut: 5000
                });
                break;
              case 500:
                errorFormat.code =  error.error.hasOwnProperty('code') ? error.error.code : null;
                errorFormat.message = `Aviso: ${error.error.message}`;
                this.toastr.error(errorFormat.message, null, {
                  positionClass: 'toast-bottom-center',
                  progressAnimation: 'decreasing',
                  progressBar: true,
                  timeOut: 5000
                });
                break;
            }
          }
               
          return throwError(errorFormat);
        })
      )
  }
}
